import React, { Component } from "react";

export class DetailPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLabels: [],
      loading: false,
      showPopup: false,
    };
  }

  labelClickHandler = (label) => {
    console.log("label is", label);
    let arr = [...this.state.selectedLabels];
    let newArr = [];
    if (arr.includes(label.toLowerCase())) {
      newArr = arr.filter((i) => i !== label.toLowerCase());
    } else {
      arr.push(label.toLowerCase());
      newArr = [...arr];
    }
    this.setState({
      selectedLabels: newArr,
    });
  };

  submitLabelsHandler = () => {
    if (
      this.state.selectedLabels &&
      this.state.selectedLabels.length > 0 &&
      this.props.selectedPostActivity
    ) {
      this.setState({
        loading: true,
      });
      let reqData = {
        activity_name: this.props.selectedPostActivity,
        label: this.state.selectedLabels,
      };
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify(reqData);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        "https://d1zez9d7l5hgkm.cloudfront.net/v1/ailabel/addlabels",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log("result is ", result);
          if (
            result &&
            (result.resultFlag === 1 || result.resultFlag === "1")
          ) {
            this.setState({
              showPopup: true,
              selectedLabels: [],
            });
          } else {
            alert(
              result &&
                (result.message ? result.message : "Something went wrong")
            );
          }
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
          });
        });
    }
  };

  render() {
    const { image_url, detail } = this.props;
    console.log("imageurl is ", image_url);
    return (
      <div>
        <div className="popup_pos popup_pos_mod">
          <div className="popupmodbg popup_bg">
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <img
                  src={image_url}
                  className="img-fluid rounded-start img_mod"
                  alt="selected image"
                />
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="card-body card_height">
                  <div className="row">
                    {detail && detail.AILabel && detail.AILabel.length > 0 && (
                      <React.Fragment>
                        {" "}
                        <div className="col-md-3">
                          {" "}
                          <strong> AI Label : </strong>{" "}
                        </div>
                        <div className="col-md-9">
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {detail.AILabel.map((item) => {
                              return (
                                <span
                                  onClick={() => {
                                    this.labelClickHandler(item.label);
                                  }}
                                  style={{
                                    padding: "5px 10px",
                                    background: "#ccc",
                                    borderRadius: "5px",
                                    color: "#000",
                                    margin: "0 5px 10px 5px",
                                    cursor: "pointer",
                                  }}
                                  className={`label_val ${
                                    this.state.selectedLabels.includes(
                                      item.label.toLowerCase()
                                    )
                                      ? "selected_ai_label"
                                      : ""
                                  }`}
                                  key={item.id}
                                >
                                  {item.label}
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {detail && detail.AIface && detail.AIface.length > 0 && (
                      <React.Fragment>
                        <div className="col-md-3">
                          {" "}
                          <strong> AI Face : </strong>{" "}
                        </div>
                        <div className="col-md-9">
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {detail.AIface.map((item) => {
                              return (
                                <span
                                  style={{
                                    padding: "5px 10px",
                                    background: "#ccc",
                                    borderRadius: "5px",
                                    color: "#000",
                                    margin: "0 5px 10px 5px",
                                  }}
                                  className="label_val"
                                  key={item.id}
                                >
                                  {`${item.gender} - ${item.count}`}
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {detail && detail.AIText && detail.AIText.length > 0 && (
                      <React.Fragment>
                        {" "}
                        <div className="col-md-3">
                          {" "}
                          <strong> AI Text : </strong>{" "}
                        </div>
                        <div className="col-md-9">
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {detail.AIText.map((item) => {
                              return (
                                <span
                                  style={{
                                    padding: "5px 10px",
                                    background: "#ccc",
                                    borderRadius: "5px",
                                    color: "#000",
                                    margin: "0 5px 10px 5px",
                                  }}
                                  className="label_val"
                                  key={item.id}
                                >
                                  {item.text}
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <button
                disabled={
                  this.state.selectedLabels &&
                  this.state.selectedLabels.length < 1
                }
                style={{
                  position: "fixed",
                  right: "100px",
                  bottom: "30px",
                }}
                onClick={() => this.submitLabelsHandler()}
                className="btn btn-primary"
              >
                Submit Labels
              </button>
              <button
                disabled={this.state.loading}
                style={{
                  position: "fixed",
                  right: "30px",
                  bottom: "30px",
                }}
                onClick={() => this.props.close()}
                className="btn btn-danger"
              >
                Close
              </button>
            </div>
          </div>
        </div>

        {this.state.loading && (
          <div className="loader_bg">
            <div className="loader_img">
              <img src="/img/loader.png" alt="" />
            </div>
          </div>
        )}

        {this.state.showPopup && (
          <div className="loader_cont_bg">
            <div className="loader_content">
              <img src="/img/check.svg" alt="" />
              <h5>Submitted Successfully</h5>
              <button
                onClick={() => {
                  this.setState({
                    showPopup: false,
                  });
                }}
                className="btn btn-success"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DetailPopup;



// WEBPACK FOOTER //
// ./src/Components/ModiRally/DetailPopup.jsx